/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_AliasInputs */

const en_entity_alias = /** @type {(inputs: Entity_AliasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alias`)
};

const de_entity_alias = /** @type {(inputs: Entity_AliasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alias`)
};

/**
* | output |
* | --- |
* | "Alias" |
*
* @param {Entity_AliasInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_alias = /** @type {((inputs?: Entity_AliasInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_AliasInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_alias(inputs)
	return de_entity_alias(inputs)
});